import { FONT_SIZE_PX } from "config/theme/constants";
import styled from "styled-components";

export const TableHeaderWrapper = styled.div`
  .header-container-with-head {
    margin: 5px;
    display: flex;
    justify-content: space-between;
    border: 1px;
  }
  .header-container {
    margin: 10px;
    display: flex;
    justify-content: end;
  }
`;

export const TableHeading = styled.div`
  font-size: ${FONT_SIZE_PX.xxxl};
  color: "#082241";
  font-weight: normal;
  font-family: "Poppins";
  opacity: 1;
`;
